import React, { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { updateProfile } from "../../../../../redux/profile/action";
import { useDispatch } from "react-redux";
import { LeaveComapany, postTeam } from "../../../../../redux/team/action";
import LoginLoaderButton from "../../../../Common/Loader/LoginLoaderButton";

export default function LeaveCompanyModel({ setLeavemodel, companyid }) {
  const [formData, setFormData] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleSubmit = () => {
    setLoading(true);

    const data = {
      company_id: companyid,
      type: 9,
    };
    dispatch(LeaveComapany(data));
    setLeavemodel((state) => !state);
    setLoading(false);
  };

  return (
    <>
      <div className="add-task">
        <h6>Leave Company</h6>
        <button
          onClick={() => setLeavemodel((state) => !state)}
          className="btn close-button"
        >
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
            alt=""
          />
        </button>
      </div>
      <ModalBody>
        <p>Are you Sure , You Want to Leave Company</p>
      </ModalBody>
      <div className="modal-footer" style={{ marginTop: 50,columnGap:'30px' , flexWrap:'nowrap' }}>
        <button
          disabled={loading}
          onClick={() => setLeavemodel((state) => !state)}
          className="btn"
          style={{ background: "#fff", color: "black", border: "2px solid " }}
          type="submit"
        >
          Cancel
        </button>
        <button
          disabled={loading}
          onClick={() => handleSubmit()}
          className="btn"
          type="submit"
        >
          {loading ? <LoginLoaderButton /> : "Yes"}
        </button>
      </div>
    </>
  );
}
